import { COMMON_ERROR } from 'utils/ErrorMessages'

import { SEGMENTS_REQUEST_ASYNC } from '../constants'

import { SELECT_ALL, UNSELECT_ALL } from './CheckboxCounterContainer/constants'
import { EDIT_ASYNC, SELECT_TOGGLE } from './TableRow/constants'
import {
  ADD_ASYNC,
  CHANGE_EXCLUDED_TAGS,
  CHANGE_INCLUDED_TAGS,
  DELETE_MANY_ASYNC,
  RESET_TAGS_VALUES,
  SET_TAGS_PAGE,
  SET_TAGS_SEARCH,
  TAGS_REQUEST_ASYNC,
} from './constants'

const defaultTagsObject = {
  items: [],
  page: 1,
  search: '',
  loader: false,
  error: null,
  totalPages: 1,
}

export default function () {
  const initialState = {
    loader: false,
    addSegmentLoader: false,
    addSegmentMessage: null,
    addSegmentStatus: false,
    data: {
      items: [],
    },
    tags: {
      ...defaultTagsObject,
    },
    addNewSegment: {
      includedTags: [],
      excludedTags: [],
    },
    error: null,
    selectedIds: {},
    message: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEGMENTS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, message: null }
      case SEGMENTS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            items: action.payload.data,
          },
          loader: false,
          selectedIds: {},
        }
      case SEGMENTS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case SEGMENTS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case ADD_ASYNC.INITIATE:
        return {
          ...state,
          addSegmentMessage: null,
          addSegmentLoader: true,
          addSegmentStatus: false,
        }
      case ADD_ASYNC.SUCCESS:
        return {
          ...state,
          addSegmentLoader: false,
          addSegmentMessage: action.payload.data.message || null,
          addSegmentStatus: action.payload.data.success,
        }
      case ADD_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          addSegmentLoader: false,
          addSegmentMessage: COMMON_ERROR,
          addSegmentStatus: false,
        }
      case ADD_ASYNC.CANCEL:
        return {
          ...state,
          addSegmentLoader: false,
          addSegmentMessage: null,
          addSegmentStatus: false,
        }
      case DELETE_MANY_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
          loader: true,
        }
      case DELETE_MANY_ASYNC.SUCCESS:
        return {
          ...state,
          message: action.payload.data.message || null,
          loader: false,
        }
      case DELETE_MANY_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DELETE_MANY_ASYNC.CANCEL:
        return { ...state, loader: false }
      case SELECT_ALL: {
        state.data.items.map((elem) => (state.selectedIds[elem.id] = true))
        return { ...state, selectedIds: { ...state.selectedIds } }
      }
      case UNSELECT_ALL:
        return {
          ...state,
          selectedIds: {},
          selectAll: false,
        }
      case SELECT_TOGGLE: {
        if (state.selectedIds[action.payload.id]) {
          delete state.selectedIds[action.payload.id]
        } else {
          state.selectedIds[action.payload.id] = true
        }
        return {
          ...state,
          selectedIds: { ...state.selectedIds },
        }
      }
      case EDIT_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
          data: {
            ...state.data,
            items: state.data.items.map((elem) => ({
              ...elem,
              loader: elem.id === action.payload.id ? true : elem.loader,
            })),
          },
        }
      case EDIT_ASYNC.SUCCESS: {
        const id = Number(action.payload.data.id)
        return {
          ...state,
          message: action.payload.data.message || 'Segment successfully changed.',
          data: {
            ...state.data,
            items: state.data.items.map((elem) => ({
              ...elem,
              loader: elem.id === id ? false : elem.loader,
            })),
          },
        }
      }
      case EDIT_ASYNC.ERROR:
        return {
          ...state,
          message: COMMON_ERROR,
          data: {
            ...state.data,
            items: state.data.items.map((elem) => ({ ...elem, loader: false })),
          },
        }
      case EDIT_ASYNC.CANCEL:
        return {
          ...state,
          message: null,
          data: {
            ...state.data,
            items: state.data.items.map((elem) => ({
              ...elem,
              loader: elem.id === action.payload.id ? false : elem.loader,
            })),
          },
        }
      case TAGS_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          tags: {
            ...state.tags,
            loader: true,
            error: null,
          },
        }
      case TAGS_REQUEST_ASYNC.SUCCESS: {
        const tags = action.payload.data.tags.map((elem) => ({
          name: elem.name,
          id: elem.id,
          type: elem.auto_tag_type,
        }))

        return {
          ...state,
          tags: {
            ...state.tags,
            items: state.tags.page === 1 ? tags : [...state.tags.items, ...tags],
            totalPages: action.payload.data.lastPageNum,
            loader: false,
          },
        }
      }
      case TAGS_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          tags: {
            ...state.tags,
            loader: false,
            error: action.error,
          },
        }
      case TAGS_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          tags: {
            ...state.tags,
            loader: false,
          },
        }
      case SET_TAGS_PAGE:
        return {
          ...state,
          tags: {
            ...state.tags,
            page: action.payload.page,
          },
        }
      case SET_TAGS_SEARCH:
        return {
          ...state,
          tags: {
            ...state.tags,
            search: action.payload.search,
          },
        }
      case CHANGE_INCLUDED_TAGS:
        return {
          ...state,
          addNewSegment: {
            ...state.addNewSegment,
            includedTags: action.payload.value,
          },
        }
      case CHANGE_EXCLUDED_TAGS:
        return {
          ...state,
          addNewSegment: {
            ...state.addNewSegment,
            excludedTags: action.payload.value,
          },
        }
      case RESET_TAGS_VALUES:
        return {
          ...state,
          addNewSegment: {
            includedTags: [],
            excludedTags: [],
          },
        }
      default:
        return state
    }
  }
}
